import { validateCompliance } from "utils";

export const formFields = [
  {
    label:'Δεν έχει λάβει για την ίδια επένδυση άλλη χρηματοδότηση από οποιοδήποτε πρόγραμμα ή φορέα.',
    id: 'terms0',
    name: 'terms0',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Tο συνολικό ποσό των ενισχύσεων ήσσονος σημασίας (De Minimis) που έχει λάβει στο παρελθόν, συμπεριλαμβανομένης της ενίσχυσης από αυτό το Πρόγραμμα, δεν υπερβαίνει το ποσό των €300.000 σε οποιαδήποτε περίοδο τριών ετών, λαμβάνοντας υπόψη όλες τις σχετικές διατάξεις του Κανονισμού 2831/2023 (de minimis) και τις προβλέψεις του Οδηγού του Προγράμματος.',
    id: 'terms1',
    name: 'terms1',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Λειτουργεί νόμιμα και συμμορφώνονται με τη σχετική ενωσιακή και εθνική περιβαλλοντική νομοθεσία.',
    id: 'terms2',
    name: 'terms2',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Θα διαθέσει, εφόσον της ζητηθεί σε πιθανό έλεγχο, κάθε πιθανό έγγραφο που αποδεικνύει τη νόμιμη λειτουργία αυτής, σύμφωνα με την κείμενη νομοθεσία και την ασκούμενη δραστηριότητά (π.χ. άδεια λειτουργίας, απαλλακτικό άδειας λειτουργίας, γνωστοποίηση έναρξης λειτουργίας, την τυχόν κατά περίπτωση προβλεπόμενη περιβαλλοντική αδειοδότηση, κλπ.). ',
    id: 'terms3',
    name: 'terms3',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Δεν βρίσκεται υπό πτώχευση, εκκαθάριση ή αναγκαστική διαχείριση.',
    id: 'terms4',
    name: 'terms4',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Δεν υπάρχει εκκρεμής διαταγή ανάκτησης ενίσχυσης που κρίθηκε παράνομη ή ασύμβατη με το πλαίσιο κρατικών ενισχύσεων.',
    id: 'terms5',
    name: 'terms5',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Δεν έχουν επιβληθεί εις βάρος της τα δύο τελευταία έτη πριν από την ημερομηνία υποβολής Αίτησης Συμμετοχής στο Πρόγραμμα:• τουλάχιστον τρεις (3) πράξεις επιβολής προστίμου από τα αρμόδια ελεγκτικά όργανα του Σώματος Επιθεώρησης Εργασίας για παραβάσεις της εργατικής νομοθεσίας που χαρακτηρίζονται, σύμφωνα με την υπουργική απόφαση 2063/Δ1632/2011 (Β΄ 266), όπως εκάστοτε ισχύει, ως «υψηλής» ή «πολύ υψηλής» σοβαρότητας, οι οποίες προκύπτουν αθροιστικά από τρεις (3) διενεργηθέντες ελέγχους, ή• τουλάχιστον δύο (2) πράξεις επιβολής προστίμου από τα αρμόδια ελεγκτικά όργανα του Σώματος Επιθεώρησης Εργασίας για παραβάσεις της εργατικής νομοθεσίας που αφορούν την αδήλωτη εργασία, οι οποίες προκύπτουν αθροιστικά από δύο (2) διενεργούντες ελέγχους.Οι οποίες να έχουν αποκτήσει τελεσίδικη και δεσμευτική ισχύ.',
    id: 'terms6',
    name: 'terms6',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Έχει την ιδιότητα της Μικρής ή Πολύ μικρής επιχείρησης σύμφωνα με τον Ορισμό της ΜμΕ στη Σύσταση της Επιτροπής 2003/361/ΕΚ, λαμβανομένων υπόψη των όρων για τη διατήρηση της ιδιότητας αυτής.',
    id: 'terms7',
    name: 'terms7',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Δεν χαρακτηρίζεται ως προβληματική, σύμφωνα με όσα ορίζονται στις σχετικές Κατευθυντήριες Οδηγίες της Ευρωπαϊκής Επιτροπής.',
    id: 'terms8',
    name: 'terms8',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
]

export const formFields1 = [
   {
    label: 'Αποδέχομαι τους όρους συμμετοχής και τις προϋποθέσεις του Προγράμματος.',
    id: 'terms9',
    name: 'terms9',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Αποδέχομαι τους όρους χρήσης των πληροφοριακών υποδομών του Προγράμματος.',
    id: 'terms10',
    name: 'terms10',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Δίδω τη συγκατάθεση μου για την επεξεργασία προσωπικών δεδομένων και παρέχω εξουσιοδότηση για την άντληση από τα Πληροφοριακά Συστήματα του Δημοσίου όλων των αναγκαίων στοιχείων για τον έλεγχο επιλεξιμότητας της αίτησης (επωνυμία, Α.Φ.Μ., αρμόδια Δ.Ο.Υ., ΚΑΔ, νομική μορφή, σώρευση κρατικών ενισχύσεων κλπ).',
    id: 'terms11',
    name: 'terms11',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Έλαβα γνώση και αποδέχομαι τους όρους και προϋποθέσεις του Οδηγού του προγράμματος.',
    id: 'terms12',
    name: 'terms12',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  // {
  //   label: 'Αποδοχή να υπαχθούν σε πιθανό προγραμματισμένο επιτόπιο έλεγχο από αρμόδιες ελεγκτικές αρχές μετά από πρότερη συνεννόηση, διευκολύνοντας τα αρμόδια όργανα και παρέχοντας κάθε αναγκαία σχετική πληροφορία.',
  //   id: 'terms13',
  //   name: 'terms13',
  //   type: 'checkbox',
  //   rules: [
  //     {
  //       type: 'boolean',
  //       transform: value => value || undefined,
  //     },
  //     { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
  //     () => ({
  //       validator(_, value) {
  //         return validateCompliance(value);
  //       },
  //     }),
  //   ],
  //   asterisk: true,
  // },
  {
    label: 'Oλες οι πληροφορίες που είναι καταχωρημένες στην Αίτηση δανείου ΤΑΑ είναι ακριβείς και αληθείς.',
    id: 'terms13',
    name: 'terms13',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
];